import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation(['errors', 'nav']);

  return (
    <div className="page">
      <div className="state-card">
        <h3>{t('errors:notFound')}</h3>
        <Link to="/" className="btn btn-primary">
          {t('nav:home')}
        </Link>
      </div>
    </div>
  );
}
